import React from "react";
import { Link, useNavigate } from "react-router-dom";
import CommonHeader from "../../components/elements/CommonHeader";
import tripRequestLogo from "../../assets/images/trip_request_icon.svg";
import ROUTE_PATHS from "../../utils/routePaths";
import AirportLocationInformation from "../Trip Details/views/AirportLocationInformation";
import UnregisteredAircraftTripAircraftDetails from "./views/UnregisteredAircraftTripAircraftDetails";
import UnregisteredAircraftTripPaymentInformation from "./views/UnregisteredAircraftTripPaymentInformation";
import "./css/UnregisteredAircraftTripDetails.css";

const UnregisteredAircraftTripDetails = () => {
  const navigate = useNavigate();

  let stored = null;
  try {
    const raw = localStorage.getItem("unregisteredAircraftSelectedTrip");
    stored = raw ? JSON.parse(raw) : null;
  } catch (e) {
    stored = null;
  }

  const tripData = stored?.tripData;
  const departureAirport = stored?.departureAirport;
  const arrivalAirport = stored?.arrivalAirport;

  const listPage = stored?.listPage ?? 1;
  const detailsPage = stored?.detailsPage ?? 1;

  const adaptedTripData = tripData
    ? {
        ...tripData,
        departureAirport: departureAirport ?? tripData?.departureAirport,
        arrivalAirport: arrivalAirport ?? tripData?.arrivalAirport,
        departureAirportTerminal:
          tripData?.departureAirportTerminal ?? { name: "Main Terminal" },
        arrivalAirportTerminal:
          tripData?.arrivalAirportTerminal ?? { name: "Main Terminal" },
      }
    : null;

  // If user refreshes and we don't have stored data, send them back to list
  if (!tripData) {
    navigate(ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_DETAILS, {
      state: { listPage, detailsPage },
      replace: true,
    });
    return null;
  }

  return (
    <div className="unregistered-aircraft-trip-details-page">
      <CommonHeader
        centerLogoSrc={tripRequestLogo}
        headerText="Unregistered Aircraft Trips"
        backContent={
          <div className="navigation-header">
            <Link
              to={ROUTE_PATHS.TRIP_REQUEST_PAGE}
              state={{ currentPage: listPage }}
              className="navigation-header-link"
            >
              Home/
            </Link>
            <Link
              to={ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_PAGE}
              state={{ currentPage: listPage }}
              className="navigation-header-link"
            >
              Unregistered Aircraft Trips/
            </Link>
            <Link
              to={ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_DETAILS}
              state={{ listPage, detailsPage }}
              className="navigation-header-link"
            >
              Details/
            </Link>
            <span className="navigation-header-link">Trip</span>
          </div>
        }
      />

      <div className="unregistered-aircraft-trip-details-content">
        <UnregisteredAircraftTripAircraftDetails tripData={tripData} />
        <AirportLocationInformation
          tripData={adaptedTripData}
          showStatus={false}
        />
        <UnregisteredAircraftTripPaymentInformation tripData={tripData} />
      </div>
    </div>
  );
};

export default UnregisteredAircraftTripDetails;
